export default __webpack_public_path__ + "67e7191731c75016efe4fd4ceb163afa.svg";